
/**
 * Created by rlopez on 11/28/16.
 */
// ActionDetailsView.js

import {View} from 'backbone'
import template from '../../../../../templates/dashboard/connections/details/action-directory-services.ejs';
import * as gridModels from '../action-type/ActionGridModels.js';
import util from '../../../../service/util/Util.js';
import constants from '../../../../constants/Constants.js';

import _ from 'lodash';

class ActionDirectoryServices extends View {
    initialize(opts){

        this.template = template;
        this.actionService = opts.actionService;

        this.events = {
            'change input[name=DistinguishedName]':'changeDistinguishedName',
            'change input[name=_distinctResults]':'changeDistinct',
            "click button[name=addSend], button[name=addReturn]"          : "itemNew",
            "click button[name=removeSend], button[name=removeReturn]"    : "itemRemove",
            "click button[name=upSend], button[name=upReturn]"            : "itemUp",
            "click button[name=downSend], button[name=downReturn]"        : "itemDown",
            "click button[name=autoSend], button[name=autoReturn]"        : "autoComplete"
        };
        this.onResize();
        this.listenTo(this.model, 'change', this.render);

        return this;
    }

    changeDistinguishedName() {
        return this.actionService.changeDistinguishedName.apply(this.actionService, arguments);
    }

    changeTableName(){
        return this.actionService.changeTableName.apply(this.actionService, arguments);
    }

    changeDistinct(){
        return this.actionService.changeDistinct.apply(this.actionService, arguments);
    }

    itemNew(){
        return this.actionService.itemNew.apply(this.actionService, arguments);
    }

    itemRemove(){
        return this.actionService.itemRemove.apply(this.actionService, arguments);
    }

    itemDown(){
        return this.actionService.itemDown.apply(this.actionService, arguments);
    }

    itemUp(){
        return this.actionService.itemUp.apply(this.actionService, arguments);
    }

    autoComplete(){
        return this.actionService.autoComplete.apply(this.actionService, arguments);
    }



    // Listening on the resize event of the window to call the resizeGrid method on the parent an adapt the grid.
    onResize(){
        $(window).bind('resize',() => {this.resizeGrid();})
    }

    // Method that renders an scroll in the grid in order to navigate the same on small screens.
    resizeGrid(){
        let grid = $('.ui-jqgrid-btable');
        if (grid) {
            grid.each(function(index) {
                let gridId = $(this).attr('id');
                let gridParentWidth = $('#gbox_' + gridId).parent().width();
                $('#' + gridId).setGridWidth(gridParentWidth);
            });
        }
    }

    renderGridsByType(){
        console.log("Re rendering Grid");
        let currentModel = this.model.get('currentActionDetails'),
            self=this;
        $('.select,.update,.insert,.delete').addClass('hide');

        // PF-2110 temp HACK. Upstream code setting model to connection type, not connection's action type
        if (currentModel.Type.length === 1){
            // Convert to CONNECTION_WEB_SERVICES_STRING_RESULT
            currentModel.Type += "1";
        }
        switch (currentModel.Type){
            case constants.CONNECTION_DIRECTORY_SERVICES_SELECT:
                this.renderParametersGrid(
                    gridModels.GRID_PARAMETERS_MODEL_SHOWN_OPERATION,
                    gridModels.GRID_DIRECTORY_SERVICES_PARAMETER_HEADERS,
                    constants.CONNECTION_SELECT_SEND_CONTAINER,
                    gridModels.GRID_PARAMETERS_MODEL_HIDDEN_OPERATION,
                    gridModels.GRID_DIRECTORY_SERVICES_PARAMETER_HEADERS,
                    constants.CONNECTION_SELECT_RETURN_CONTAINER,
                );
                $('.select').removeClass('hide');
                break;
            case constants.CONNECTION_DIRECTORY_SERVICES_INSERT:
                currentModel.ActionXML.Action.Receive.Parameter = [];
                this.renderParametersGrid(
                    gridModels.GRID_PARAMETERS_MODEL_HIDDEN_OPERATION,
                    gridModels.GRID_DIRECTORY_SERVICES_PARAMETER_HEADERS,
                    constants.CONNECTION_INSERT_SEND_CONTAINER
                );
                $('.insert').removeClass('hide');
                break;
            case constants.CONNECTION_DIRECTORY_SERVICES_UPDATE:
                currentModel.ActionXML.Action.Receive.Parameter = [];
                this.renderParametersGrid(
                    gridModels.GRID_PARAMETERS_MODEL_SHOWN_OPERATION,
                    gridModels.GRID_DIRECTORY_SERVICES_PARAMETER_HEADERS,
                    constants.CONNECTION_UPDATE_SEND_CONTAINER,
                    gridModels.GRID_PARAMETERS_MODEL_HIDDEN_OPERATION,
                    gridModels.GRID_DIRECTORY_SERVICES_PARAMETER_HEADERS,
                    constants.CONNECTION_UPDATE_RETURN_CONTAINER,
                );
                $('.update').removeClass('hide');
                break;
            case constants.CONNECTION_DIRECTORY_SERVICES_DELETE:
                currentModel.ActionXML.Action.Receive.Parameter = [];
                this.renderParametersGrid(
                    gridModels.GRID_PARAMETERS_MODEL_SHOWN_OPERATION,
                    gridModels.GRID_DIRECTORY_SERVICES_PARAMETER_HEADERS,
                    constants.CONNECTION_DELETE_SEND_CONTAINER
                );
                $('.delete').removeClass('hide');
                break;
        }
        this.resizeGrid();
    }

    renderParametersGrid(colSendModel,colSendNames,colSendContainer,colReturnModel,colReturnNames,colReturnContainer){
        let currentModel = this.model.get('currentActionDetails'),
            self=this;
        console.log("Current Action Details",currentModel);
        let sendItemsToRender = [];
        const isUpdate = currentModel.Type === constants.CONNECTION_DIRECTORY_SERVICES_UPDATE;
        const isInsert = currentModel.Type === constants.CONNECTION_DIRECTORY_SERVICES_INSERT;

        if (currentModel.ActionXML.Action.Send.Parameter instanceof Array){
            //For directory Service when the action type is insert, the operation is -1 so we need to filter elements where operation is this one
            if(isInsert){
                sendItemsToRender = currentModel.ActionXML.Action.Send.Parameter.filter(item => item._operation === '-1');
            }else{
                sendItemsToRender = currentModel.ActionXML.Action.Send.Parameter.filter(item => item._operation !== '-1');
            }
        }else {
            if(isInsert){
                if (currentModel.ActionXML.Action.Send.Parameter && currentModel.ActionXML.Action.Send.Parameter._operation === '-1'){
                    sendItemsToRender = [currentModel.ActionXML.Action.Send.Parameter];
                }
            }else{
                if (currentModel.ActionXML.Action.Send.Parameter && currentModel.ActionXML.Action.Send.Parameter._operation !== '-1'){
                    sendItemsToRender = [currentModel.ActionXML.Action.Send.Parameter];
                }
            }
            
        }

        let returnItemsToRender = [];
        if (isUpdate) {
            if (currentModel.ActionXML.Action.Send.Parameter instanceof Array) {
                returnItemsToRender = currentModel.ActionXML.Action.Send.Parameter.filter(item => item._operation === '-1');
            } else {
                returnItemsToRender = [currentModel.ActionXML.Action.Send.Parameter];
            }
        } else {
            returnItemsToRender = currentModel.ActionXML.Action.Receive.Parameter instanceof Array
                ? currentModel.ActionXML.Action.Receive.Parameter
                : [currentModel.ActionXML.Action.Receive.Parameter];
        }

        let gridSendObject = util.getGridObject(this,{
            colModel:colSendModel,
            colNames:colSendNames,
            autowidth:true,
            height: 300,
            scrollOffset:0,
            ondblClickRow:this.ondblClickRowSend});
        let gridReturnObject = util.getGridObject(this,{
            colModel:colReturnModel,
            colNames:colReturnNames,
            autowidth:true,
            height: 300,
            scrollOffset:0,
            ondblClickRow:this.ondblClickRowReceive});
        $(colSendContainer).jqGrid(gridSendObject);
        $(colReturnContainer).jqGrid(gridReturnObject);
        _.forEach(sendItemsToRender, (field, index) => {
            self.fillNewRow(colSendContainer, index, field['_fixedValue'], field['_id'], field['_isFixed'],
                field['_name'], field['_operation'], field['_value']);
        });
        _.forEach(returnItemsToRender, (field, index) => {
            self.fillNewRow(colReturnContainer, index, field['_fixedValue'], field['_id'], field['_isFixed'],
                field['_name'], field['_operation'], field['_value']);
        });
    }

    ondblClickRowSend (rowid, iRow,iCol){
        let containerToWork= '#' + this.id;
        if(iCol === 5) {
            $(containerToWork).jqGrid('setColProp', '_value', {editable: true});
            $(containerToWork).jqGrid('setColProp', '_name', {editable: false});
        }else{
            $(containerToWork).jqGrid('setColProp', '_value', {editable: false});
            $(containerToWork).jqGrid('setColProp', '_name', {editable: true});
        }
        $(containerToWork).editCell(iRow, iCol, true);
    }

    ondblClickRowReceive (rowid, iRow,iCol){
        let containerToWork= '#' + this.id;
        if(iCol === 5) {
            $(containerToWork).jqGrid('setColProp', '_value', {editable: true});
            $(containerToWork).jqGrid('setColProp', '_name', {editable: false});
        }else{
            $(containerToWork).jqGrid('setColProp', '_value', {editable: false});
            $(containerToWork).jqGrid('setColProp', '_name', {editable: true});
        }
        $(containerToWork).editCell(iRow, iCol, true);
    }

    afterSaveCell(rowId, cellName, value, iRow, iCol){
        let currentGrid=this.model.get('currentGridSelector'),
            currentModel=this.model.get('currentActionDetails'),
            isSend = currentGrid.indexOf('Send') > 0;
        console.log('Current Grid',currentGrid);
        console.log("Editing",rowId);
        console.log("Editing",cellName);
        console.log("Editing",value);
        if(isSend){
            if(cellName === '_value'
                && currentModel.ActionXML.Action.Send.Parameter[rowId]['_isNew']
                && currentModel.ActionXML.Action.Send.Parameter[rowId]['_isNew'] !== 'false'){

                currentModel.ActionXML.Action.Send.Parameter[rowId]['_name'] = value;
                currentModel.ActionXML.Action.Send.Parameter[rowId]['_isNew']=false;
            }
            else if(cellName === '_name'){
                currentModel.ActionXML.Action.Send.Parameter[rowId]['_isNew']=false;
            }
            currentModel.ActionXML.Action.Send.Parameter[rowId][cellName] = value;
        }
        else{
            if (currentModel.Type === constants.CONNECTION_DIRECTORY_SERVICES_UPDATE){
                let sendValueItems = currentModel.ActionXML.Action.Send.Parameter.filter(item => item._operation === '-1');
                if (sendValueItems){
                    if(cellName === '_value'
                        && sendValueItems[rowId]['_isNew']
                        && sendValueItems[rowId]['_isNew'] !== 'false'){
                        sendValueItems[rowId]['_name'] = value;
                        sendValueItems[rowId]['_isNew']=false;
                    }
                    sendValueItems[rowId][cellName] = value;
                }
            }else{
                if(cellName === '_value'
                    && currentModel.ActionXML.Action.Receive.Parameter[rowId]['_isNew']
                    && currentModel.ActionXML.Action.Receive.Parameter[rowId]['_isNew'] !== 'false'){
                    currentModel.ActionXML.Action.Receive.Parameter[rowId]['_name'] = value;
                    currentModel.ActionXML.Action.Receive.Parameter[rowId]['_isNew']=false;
                }
                currentModel.ActionXML.Action.Receive.Parameter[rowId][cellName] = value;
            }
        }
        this.model.set('currentActionDetails',currentModel,{silent:true});
        this.model.set('hasChanges',true,{silent:true});
        this.model.trigger('change');
        console.log("Model After Save Cell",currentModel);
    }

    onSelectRow(){}

    onCellSelect(){}

    fillNewRow(grid,index, _fixedValue,_id,_isFixed,_name, _operation, _value) {
        $(grid).addRowData(index, {
            '_fixedValue':_fixedValue,
            '_id': _id,
            '_isFixed':_isFixed,
            '_name':_name,
            '_operation':_operation,
            '_value':_value
        });
    }

    setRow(rowId, e){
        console.log('before select row',e);
        $(`#${e.currentTarget.id}`).jqGrid('setSelection', rowId);
        this.model.set('currentGridSelector',`#${e.currentTarget.id}`,{silent:true});
    }

    afterEditCell(rowId, cellName, value, iRow, iCol){
        let self=this;
        $("#"+iRow+"_"+cellName).bind('blur',function(){
            $(self.model.get('currentGridSelector')).saveCell(iRow,iCol);
        });
    }

    render(){
        console.log("Rendering Grids");
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.renderGridsByType();

        this.delegateEvents();
        return this;
    }

}

export default ActionDirectoryServices;